export function isEnterKeyEvent(event) {
  const nativeEvent = event?.nativeEvent;
  const key = nativeEvent?.key ?? event?.key;
  const keyCode = nativeEvent?.keyCode ?? nativeEvent?.which ?? event?.keyCode;
  return key === "Enter" || keyCode === 13;
}

export function getSearchEnterTarget({
  searchText,
  items = [],
  getItemKey,
  overrideKey = null,
}) {
  if (String(searchText ?? "").trim().length === 0 || !Array.isArray(items) || items.length === 0) {
    return null;
  }

  if (typeof getItemKey === "function" && overrideKey != null) {
    const overrideItem = items.find((item) => getItemKey(item) === overrideKey);
    if (overrideItem) {
      return overrideItem;
    }
  }

  return items[0] ?? null;
}
